export const getOktaAdministeredUsers = ({ token, client, cursor }) => ({
  HTTPMethod: "get",
  path: `/api/v1/sso/users`,
  queryParams: {
    filter: {
      "client-slug": client,
    },
    page: {
      size: 25,
      cursor,
    },
  },
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
